import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { UserAuthenticationService } from '../../services/user-authentication.service';
import { UserService } from '../../../shared/user.service';

@Component({
  selector: 'rwa-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements AfterViewInit {
  currentYear = new Date().getFullYear();

  @ViewChild('logoImg') logoImg: ElementRef | undefined;

  constructor(
    private userAuthenticationService: UserAuthenticationService,
    private userService: UserService,
  ) {}

  ngAfterViewInit(): void {
    // Ensure logo image loads with correct path
    if (this.logoImg) {
      this.logoImg.nativeElement.src = 'assets/images/logo.svg';
    }
  }

  async signIn(): Promise<void> {
    try {
      await this.userAuthenticationService.signIn('Google');
    } catch (e) {
      console.log(e);
    }
  }

  async signOut(): Promise<void> {
    try {
      await this.userAuthenticationService.signOut();
      this.userService.clearUser();
    } catch (e) {
      console.log(e);
    }
  }
}
